import { LockIcon } from '@carboncopyco/icons';
import { TextCaption, Tooltip } from '@carboncopyco/ui';
import classNames from 'classnames';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useRef } from 'react';

export interface RuleCardLockButtonProps {
  onClick?: () => void;
}

export const RuleCardLockButton = ({ onClick }: RuleCardLockButtonProps) => {
  const { editorDataRulesAdmin } = useFlags();
  const anchorRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <div
        ref={anchorRef}
        className={classNames(
          'w-ds-9 flex justify-center text-ds-natural-600 group-hover:opacity-100',
          editorDataRulesAdmin && 'cursor-pointer'
        )}
        onClick={editorDataRulesAdmin ? onClick : undefined}
      >
        <LockIcon size={20} />
      </div>
      {!editorDataRulesAdmin && (
        <Tooltip
          anchorRef={anchorRef}
          placement="bottom-end"
          offset={[-240, 0]}
          autoCalcArrowPosition
        >
          <span className="flex p-3 w-72">
            <TextCaption
              label="This rule is locked for editing. Contact your Demostack contact person for more details."
              color="text-ds-natural-400"
            />
          </span>
        </Tooltip>
      )}
    </>
  );
};
